const JPEG = 'image/jpeg';
const JPG = 'image/jpg';
const PNG = 'image/png';

export const ACCEPTED_FILES = `${JPEG},${JPG},${PNG}`;
export const MAX_IMAGE_SIZE = 10; // MB
export const MIN_IMAGE_WIDTH = 1200; // px

export const IMAGE_CLEANUP_DELAY = 500;
